
export let APIHost = "http://localhost:3000"
export let MessageAPIHost = "http://localhost:3030"

export let AuthenticateServer = {
    UserPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || '',
    ClientId: process.env.REACT_APP_COGNITO_CLIENT_ID || '',
    IdentityPoolId: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID || '',
    Region: process.env.REACT_APP_COGNITO_REGION || ''
}

switch (process.env.NODE_ENV) {
    case 'production':
        if (process.env.REACT_APP_ENV === "staging") {
            APIHost = process.env.REACT_APP_API_HOST || 'https://api-test.homisnursee.com';
            MessageAPIHost = process.env.REACT_APP_MESSAGE_API_HOST || 'https://msg-test.homisnursee.com';
        } else {
            APIHost = process.env.REACT_APP_API_HOST || 'https://api.homisnursee.com';
            MessageAPIHost = process.env.REACT_APP_MESSAGE_API_HOST || 'https://msg.homisnursee.com';
        }
        break;
    default:
        break;
}

export const CurrentApiVersion = "v1"
export const ApiUrl = (str: string, version: string = CurrentApiVersion) => {
    return `${APIHost}/api/${version}/` + str;
}

export const MessageApiUrl = (str: string, version: string = CurrentApiVersion) => {
    return `${MessageAPIHost}/api/${version}/${str}`;
}

export const ApiUrlRaw = (str: string) => {
    return `${APIHost}/` + str;
}

export const CustomTokenhUrl = () => {
    return ApiUrl("custom_token")
}

export const PasswordResetUrl = () => {
    return ApiUrlRaw("password_reset/reset")
}
